import { Link, useLocation } from 'react-router-dom';

import { useAssistant } from './use-assistant';

/**
 * Assistant's ways in (ASSIST-1), in the bottom right corner of every page, only where
 * Assistant is on: the hostess's screen, and the preview of the website's contact page, to
 * try the website's way as a visitor. On a phone they sit above the bottom tabs.
 */
const AssistantCorner = () => {
  const { data } = useAssistant();
  const { pathname } = useLocation();
  if (!data?.enabled) return null;
  return (
    <div
      data-app-chrome
      className="fixed bottom-[calc(4.75rem+env(safe-area-inset-bottom))] right-4 z-30 flex flex-col items-end gap-2 md:bottom-6 md:right-6"
    >
      <Link
        to="/site-preview"
        className="inline-flex h-11 items-center gap-2 rounded-pill bg-control px-4 text-sm text-fg shadow-e4 transition hover:bg-surface-hover active:translate-y-px"
      >
        <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
          <rect x="3" y="4" width="18" height="16" rx="2.5" />
          <path d="M3 9h18M7 6.5h.01M10 6.5h.01" />
        </svg>
        Website preview
      </Link>
      {!pathname.startsWith('/hostess') && (
        <Link
          to="/hostess"
          className="inline-flex h-12 items-center gap-2 rounded-pill bg-brand px-5 text-sm text-black shadow-e4 transition hover:bg-cta-hover-bg hover:text-cta-hover-fg active:translate-y-px"
        >
          <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
            <circle cx="10" cy="8" r="3.5" />
            <path d="M3.5 19.5c.8-3.2 3.4-5 6.5-5 1.5 0 2.9.4 4 1.2M18 13v6M15 16h6" />
          </svg>
          Add a visitor
        </Link>
      )}
    </div>
  );
};

export default AssistantCorner;
